/**
 * 配列の中の2つのオブジェクトが同一の値が異なっているか判定する
 * @returns true: 同じではないオブジェクトが1つ以上含まれている
 */
export const areDifferentShallowList = <T extends Object>(list: [T, T][]): boolean => list
  .map((target) => areDifferentShallow(...target))
  .filter(Boolean)
  .length > 0;

/**
 * 2つのオブジェクトが同一の値が異なっているか判定する
 * @returns true: 同じではない
 */
export const areDifferentShallow = <T extends Object>(a: T, b: T): boolean => {
  if (b === undefined && a === undefined) { return false; }
  if (b === undefined || a === undefined) { return true; }

  for (const key in a) {
    if (a[key] !== b[key]) {
      return true;
    }
  }
  return false;
};
